import { render, staticRenderFns } from "./CompositeObjectWriteDialog.vue?vue&type=template&id=47734b37&"
import script from "./CompositeObjectWriteDialog.vue?vue&type=script&lang=js&"
export * from "./CompositeObjectWriteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports